// Product Collections Vuex

import state from './collectionStates.js'
import * as getters from './collectionGetters.js'
import * as mutations from './collectionMutations.js'
import * as actions from './collectionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
